var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinalThreeGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 72,
    viewBox: "0 0 32 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31,
    rx: 15.5,
    fill: "#575757"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7109 21.1875C13.3828 21.1875 11.875 19.8906 11.7266 18.1094L11.7188 18.0156H13.0703L13.0781 18.0938C13.1953 19.2031 14.2109 19.9688 15.7109 19.9688C17.1875 19.9688 18.1953 19.1406 18.1953 17.9453V17.9297C18.1953 16.5469 17.2031 15.7734 15.625 15.7734H14.2109V14.5859H15.5625C16.9062 14.5859 17.8438 13.7578 17.8438 12.6328V12.6172C17.8438 11.4375 17.0703 10.7578 15.6953 10.7578C14.3672 10.7578 13.4219 11.4609 13.3047 12.6016L13.2969 12.6797H11.9453L11.9531 12.6016C12.1328 10.7656 13.5859 9.53906 15.6953 9.53906C17.8438 9.53906 19.2578 10.7344 19.2578 12.4453V12.4609C19.2578 13.8516 18.2734 14.8047 16.8672 15.1016V15.1328C18.5078 15.2734 19.625 16.2969 19.625 17.8984V17.9141C19.625 19.7969 17.9688 21.1875 15.7109 21.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalThreeGrey);
export default __webpack_public_path__ + "static/media/finalThreeGrey.a7b143ec50bdea3494ec6c1c18a24b91.svg";
export { ForwardRef as ReactComponent };